/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {GrowthModelResponse} from '../bioplanModels';
// @ts-ignore
import type {GrowthModelTypesResponse} from '../bioplanModels';
/**
 * ModellingGrowthApi - axios parameter creator
 * @export
 */
export const ModellingGrowthApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    growthModelsGet: async (planId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('growthModelsGet', 'planId', planId);
      const localVarPath = `/growthModels/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} growthModelId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    growthModelsGrowthModelIdDelete: async (
      growthModelId: string,
      planId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'growthModelId' is not null or undefined
      assertParamExists('growthModelsGrowthModelIdDelete', 'growthModelId', growthModelId);
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('growthModelsGrowthModelIdDelete', 'planId', planId);
      const localVarPath = `/growthModels/{growthModelId}`.replace(
        `{${'growthModelId'}}`,
        encodeURIComponent(String(growthModelId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} growthModelId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    growthModelsGrowthModelIdDownloadGet: async (
      growthModelId: string,
      planId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'growthModelId' is not null or undefined
      assertParamExists('growthModelsGrowthModelIdDownloadGet', 'growthModelId', growthModelId);
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('growthModelsGrowthModelIdDownloadGet', 'planId', planId);
      const localVarPath = `/growthModels/{growthModelId}/download`.replace(
        `{${'growthModelId'}}`,
        encodeURIComponent(String(growthModelId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get growth model by its identifier
     * @param {string} growthModelId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    growthModelsGrowthModelIdGet: async (
      growthModelId: string,
      planId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'growthModelId' is not null or undefined
      assertParamExists('growthModelsGrowthModelIdGet', 'growthModelId', growthModelId);
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('growthModelsGrowthModelIdGet', 'planId', planId);
      const localVarPath = `/growthModels/{growthModelId}`.replace(
        `{${'growthModelId'}}`,
        encodeURIComponent(String(growthModelId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Edit a growth model
     * @param {string} growthModelId
     * @param {string} planId
     * @param {string} name
     * @param {boolean} isDefault
     * @param {GrowthModelsGrowthModelIdPutAdjustmentTypeEnum} adjustmentType
     * @param {Array<number>} adjustment
     * @param {string | null} version
     * @param {File | null} [file] CSV file with growth model parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    growthModelsGrowthModelIdPut: async (
      growthModelId: string,
      planId: string,
      name: string,
      isDefault: boolean,
      adjustmentType: GrowthModelsGrowthModelIdPutAdjustmentTypeEnum,
      adjustment: Array<number>,
      version: string | null,
      file?: File | null,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'growthModelId' is not null or undefined
      assertParamExists('growthModelsGrowthModelIdPut', 'growthModelId', growthModelId);
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('growthModelsGrowthModelIdPut', 'planId', planId);
      // verify required parameter 'name' is not null or undefined
      assertParamExists('growthModelsGrowthModelIdPut', 'name', name);
      // verify required parameter 'isDefault' is not null or undefined
      assertParamExists('growthModelsGrowthModelIdPut', 'isDefault', isDefault);
      // verify required parameter 'adjustmentType' is not null or undefined
      assertParamExists('growthModelsGrowthModelIdPut', 'adjustmentType', adjustmentType);
      // verify required parameter 'adjustment' is not null or undefined
      assertParamExists('growthModelsGrowthModelIdPut', 'adjustment', adjustment);
      // verify required parameter 'version' is not null or undefined
      assertParamExists('growthModelsGrowthModelIdPut', 'version', version);
      const localVarPath = `/growthModels/{growthModelId}`.replace(
        `{${'growthModelId'}}`,
        encodeURIComponent(String(growthModelId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarFormParams.append('planId', planId as any);
      }

      if (name !== undefined) {
        localVarFormParams.append('name', name as any);
      }

      if (isDefault !== undefined) {
        localVarFormParams.append('isDefault', String(isDefault) as any);
      }

      if (adjustmentType !== undefined) {
        localVarFormParams.append('adjustmentType', adjustmentType as any);
      }
      if (adjustment) {
        localVarFormParams.append('adjustment', adjustment.join(COLLECTION_FORMATS.csv));
      }

      if (file !== undefined) {
        localVarFormParams.append('file', file as any);
      }

      if (version !== undefined) {
        localVarFormParams.append('version', version as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a new growth model
     * @param {string} planId
     * @param {string} name
     * @param {boolean} isDefault
     * @param {GrowthModelsPostAdjustmentTypeEnum} adjustmentType
     * @param {Array<number>} adjustment
     * @param {string | null} version
     * @param {GrowthModelsPostTypeEnum} type
     * @param {File | null} [file] CSV file with growth model parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    growthModelsPost: async (
      planId: string,
      name: string,
      isDefault: boolean,
      adjustmentType: GrowthModelsPostAdjustmentTypeEnum,
      adjustment: Array<number>,
      version: string | null,
      type: GrowthModelsPostTypeEnum,
      file?: File | null,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('growthModelsPost', 'planId', planId);
      // verify required parameter 'name' is not null or undefined
      assertParamExists('growthModelsPost', 'name', name);
      // verify required parameter 'isDefault' is not null or undefined
      assertParamExists('growthModelsPost', 'isDefault', isDefault);
      // verify required parameter 'adjustmentType' is not null or undefined
      assertParamExists('growthModelsPost', 'adjustmentType', adjustmentType);
      // verify required parameter 'adjustment' is not null or undefined
      assertParamExists('growthModelsPost', 'adjustment', adjustment);
      // verify required parameter 'version' is not null or undefined
      assertParamExists('growthModelsPost', 'version', version);
      // verify required parameter 'type' is not null or undefined
      assertParamExists('growthModelsPost', 'type', type);
      const localVarPath = `/growthModels/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarFormParams.append('planId', planId as any);
      }

      if (name !== undefined) {
        localVarFormParams.append('name', name as any);
      }

      if (isDefault !== undefined) {
        localVarFormParams.append('isDefault', String(isDefault) as any);
      }

      if (adjustmentType !== undefined) {
        localVarFormParams.append('adjustmentType', adjustmentType as any);
      }
      if (adjustment) {
        localVarFormParams.append('adjustment', adjustment.join(COLLECTION_FORMATS.csv));
      }

      if (file !== undefined) {
        localVarFormParams.append('file', file as any);
      }

      if (version !== undefined) {
        localVarFormParams.append('version', version as any);
      }

      if (type !== undefined) {
        localVarFormParams.append('type', type as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    growthModelsTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/growthModels/types`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ModellingGrowthApi - functional programming interface
 * @export
 */
export const ModellingGrowthApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ModellingGrowthApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async growthModelsGet(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GrowthModelResponse>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.growthModelsGet(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ModellingGrowthApi.growthModelsGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} growthModelId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async growthModelsGrowthModelIdDelete(
      growthModelId: string,
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.growthModelsGrowthModelIdDelete(
        growthModelId,
        planId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ModellingGrowthApi.growthModelsGrowthModelIdDelete']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} growthModelId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async growthModelsGrowthModelIdDownloadGet(
      growthModelId: string,
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.growthModelsGrowthModelIdDownloadGet(
        growthModelId,
        planId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ModellingGrowthApi.growthModelsGrowthModelIdDownloadGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get growth model by its identifier
     * @param {string} growthModelId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async growthModelsGrowthModelIdGet(
      growthModelId: string,
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GrowthModelResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.growthModelsGrowthModelIdGet(
        growthModelId,
        planId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ModellingGrowthApi.growthModelsGrowthModelIdGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Edit a growth model
     * @param {string} growthModelId
     * @param {string} planId
     * @param {string} name
     * @param {boolean} isDefault
     * @param {GrowthModelsGrowthModelIdPutAdjustmentTypeEnum} adjustmentType
     * @param {Array<number>} adjustment
     * @param {string | null} version
     * @param {File | null} [file] CSV file with growth model parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async growthModelsGrowthModelIdPut(
      growthModelId: string,
      planId: string,
      name: string,
      isDefault: boolean,
      adjustmentType: GrowthModelsGrowthModelIdPutAdjustmentTypeEnum,
      adjustment: Array<number>,
      version: string | null,
      file?: File | null,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GrowthModelResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.growthModelsGrowthModelIdPut(
        growthModelId,
        planId,
        name,
        isDefault,
        adjustmentType,
        adjustment,
        version,
        file,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ModellingGrowthApi.growthModelsGrowthModelIdPut']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create a new growth model
     * @param {string} planId
     * @param {string} name
     * @param {boolean} isDefault
     * @param {GrowthModelsPostAdjustmentTypeEnum} adjustmentType
     * @param {Array<number>} adjustment
     * @param {string | null} version
     * @param {GrowthModelsPostTypeEnum} type
     * @param {File | null} [file] CSV file with growth model parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async growthModelsPost(
      planId: string,
      name: string,
      isDefault: boolean,
      adjustmentType: GrowthModelsPostAdjustmentTypeEnum,
      adjustment: Array<number>,
      version: string | null,
      type: GrowthModelsPostTypeEnum,
      file?: File | null,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GrowthModelResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.growthModelsPost(
        planId,
        name,
        isDefault,
        adjustmentType,
        adjustment,
        version,
        type,
        file,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ModellingGrowthApi.growthModelsPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async growthModelsTypesGet(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GrowthModelTypesResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.growthModelsTypesGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ModellingGrowthApi.growthModelsTypesGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ModellingGrowthApi - factory interface
 * @export
 */
export const ModellingGrowthApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ModellingGrowthApiFp(configuration);
  return {
    /**
     *
     * @param {ModellingGrowthApiGrowthModelsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    growthModelsGet(
      requestParameters: ModellingGrowthApiGrowthModelsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<GrowthModelResponse>> {
      return localVarFp.growthModelsGet(requestParameters.planId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {ModellingGrowthApiGrowthModelsGrowthModelIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    growthModelsGrowthModelIdDelete(
      requestParameters: ModellingGrowthApiGrowthModelsGrowthModelIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .growthModelsGrowthModelIdDelete(requestParameters.growthModelId, requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {ModellingGrowthApiGrowthModelsGrowthModelIdDownloadGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    growthModelsGrowthModelIdDownloadGet(
      requestParameters: ModellingGrowthApiGrowthModelsGrowthModelIdDownloadGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<File> {
      return localVarFp
        .growthModelsGrowthModelIdDownloadGet(requestParameters.growthModelId, requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get growth model by its identifier
     * @param {ModellingGrowthApiGrowthModelsGrowthModelIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    growthModelsGrowthModelIdGet(
      requestParameters: ModellingGrowthApiGrowthModelsGrowthModelIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<GrowthModelResponse> {
      return localVarFp
        .growthModelsGrowthModelIdGet(requestParameters.growthModelId, requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Edit a growth model
     * @param {ModellingGrowthApiGrowthModelsGrowthModelIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    growthModelsGrowthModelIdPut(
      requestParameters: ModellingGrowthApiGrowthModelsGrowthModelIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<GrowthModelResponse> {
      return localVarFp
        .growthModelsGrowthModelIdPut(
          requestParameters.growthModelId,
          requestParameters.planId,
          requestParameters.name,
          requestParameters.isDefault,
          requestParameters.adjustmentType,
          requestParameters.adjustment,
          requestParameters.version,
          requestParameters.file,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create a new growth model
     * @param {ModellingGrowthApiGrowthModelsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    growthModelsPost(
      requestParameters: ModellingGrowthApiGrowthModelsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<GrowthModelResponse> {
      return localVarFp
        .growthModelsPost(
          requestParameters.planId,
          requestParameters.name,
          requestParameters.isDefault,
          requestParameters.adjustmentType,
          requestParameters.adjustment,
          requestParameters.version,
          requestParameters.type,
          requestParameters.file,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    growthModelsTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<GrowthModelTypesResponse> {
      return localVarFp.growthModelsTypesGet(options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for growthModelsGet operation in ModellingGrowthApi.
 * @export
 * @interface ModellingGrowthApiGrowthModelsGetRequest
 */
export interface ModellingGrowthApiGrowthModelsGetRequest {
  /**
   *
   * @type {string}
   * @memberof ModellingGrowthApiGrowthModelsGet
   */
  readonly planId: string;
}

/**
 * Request parameters for growthModelsGrowthModelIdDelete operation in ModellingGrowthApi.
 * @export
 * @interface ModellingGrowthApiGrowthModelsGrowthModelIdDeleteRequest
 */
export interface ModellingGrowthApiGrowthModelsGrowthModelIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof ModellingGrowthApiGrowthModelsGrowthModelIdDelete
   */
  readonly growthModelId: string;

  /**
   *
   * @type {string}
   * @memberof ModellingGrowthApiGrowthModelsGrowthModelIdDelete
   */
  readonly planId: string;
}

/**
 * Request parameters for growthModelsGrowthModelIdDownloadGet operation in ModellingGrowthApi.
 * @export
 * @interface ModellingGrowthApiGrowthModelsGrowthModelIdDownloadGetRequest
 */
export interface ModellingGrowthApiGrowthModelsGrowthModelIdDownloadGetRequest {
  /**
   *
   * @type {string}
   * @memberof ModellingGrowthApiGrowthModelsGrowthModelIdDownloadGet
   */
  readonly growthModelId: string;

  /**
   *
   * @type {string}
   * @memberof ModellingGrowthApiGrowthModelsGrowthModelIdDownloadGet
   */
  readonly planId: string;
}

/**
 * Request parameters for growthModelsGrowthModelIdGet operation in ModellingGrowthApi.
 * @export
 * @interface ModellingGrowthApiGrowthModelsGrowthModelIdGetRequest
 */
export interface ModellingGrowthApiGrowthModelsGrowthModelIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof ModellingGrowthApiGrowthModelsGrowthModelIdGet
   */
  readonly growthModelId: string;

  /**
   *
   * @type {string}
   * @memberof ModellingGrowthApiGrowthModelsGrowthModelIdGet
   */
  readonly planId: string;
}

/**
 * Request parameters for growthModelsGrowthModelIdPut operation in ModellingGrowthApi.
 * @export
 * @interface ModellingGrowthApiGrowthModelsGrowthModelIdPutRequest
 */
export interface ModellingGrowthApiGrowthModelsGrowthModelIdPutRequest {
  /**
   *
   * @type {string}
   * @memberof ModellingGrowthApiGrowthModelsGrowthModelIdPut
   */
  readonly growthModelId: string;

  /**
   *
   * @type {string}
   * @memberof ModellingGrowthApiGrowthModelsGrowthModelIdPut
   */
  readonly planId: string;

  /**
   *
   * @type {string}
   * @memberof ModellingGrowthApiGrowthModelsGrowthModelIdPut
   */
  readonly name: string;

  /**
   *
   * @type {boolean}
   * @memberof ModellingGrowthApiGrowthModelsGrowthModelIdPut
   */
  readonly isDefault: boolean;

  /**
   *
   * @type {string}
   * @memberof ModellingGrowthApiGrowthModelsGrowthModelIdPut
   */
  readonly adjustmentType: GrowthModelsGrowthModelIdPutAdjustmentTypeEnum;

  /**
   *
   * @type {Array<number>}
   * @memberof ModellingGrowthApiGrowthModelsGrowthModelIdPut
   */
  readonly adjustment: Array<number>;

  /**
   *
   * @type {string}
   * @memberof ModellingGrowthApiGrowthModelsGrowthModelIdPut
   */
  readonly version: string | null;

  /**
   * CSV file with growth model parameters
   * @type {File}
   * @memberof ModellingGrowthApiGrowthModelsGrowthModelIdPut
   */
  readonly file?: File | null;
}

/**
 * Request parameters for growthModelsPost operation in ModellingGrowthApi.
 * @export
 * @interface ModellingGrowthApiGrowthModelsPostRequest
 */
export interface ModellingGrowthApiGrowthModelsPostRequest {
  /**
   *
   * @type {string}
   * @memberof ModellingGrowthApiGrowthModelsPost
   */
  readonly planId: string;

  /**
   *
   * @type {string}
   * @memberof ModellingGrowthApiGrowthModelsPost
   */
  readonly name: string;

  /**
   *
   * @type {boolean}
   * @memberof ModellingGrowthApiGrowthModelsPost
   */
  readonly isDefault: boolean;

  /**
   *
   * @type {string}
   * @memberof ModellingGrowthApiGrowthModelsPost
   */
  readonly adjustmentType: GrowthModelsPostAdjustmentTypeEnum;

  /**
   *
   * @type {Array<number>}
   * @memberof ModellingGrowthApiGrowthModelsPost
   */
  readonly adjustment: Array<number>;

  /**
   *
   * @type {string}
   * @memberof ModellingGrowthApiGrowthModelsPost
   */
  readonly version: string | null;

  /**
   *
   * @type {string}
   * @memberof ModellingGrowthApiGrowthModelsPost
   */
  readonly type: GrowthModelsPostTypeEnum;

  /**
   * CSV file with growth model parameters
   * @type {File}
   * @memberof ModellingGrowthApiGrowthModelsPost
   */
  readonly file?: File | null;
}

/**
 * ModellingGrowthApi - object-oriented interface
 * @export
 * @class ModellingGrowthApi
 * @extends {BaseAPI}
 */
export class ModellingGrowthApi extends BaseAPI {
  /**
   *
   * @param {ModellingGrowthApiGrowthModelsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModellingGrowthApi
   */
  public growthModelsGet(requestParameters: ModellingGrowthApiGrowthModelsGetRequest, options?: RawAxiosRequestConfig) {
    return ModellingGrowthApiFp(this.configuration)
      .growthModelsGet(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {ModellingGrowthApiGrowthModelsGrowthModelIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModellingGrowthApi
   */
  public growthModelsGrowthModelIdDelete(
    requestParameters: ModellingGrowthApiGrowthModelsGrowthModelIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ModellingGrowthApiFp(this.configuration)
      .growthModelsGrowthModelIdDelete(requestParameters.growthModelId, requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {ModellingGrowthApiGrowthModelsGrowthModelIdDownloadGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModellingGrowthApi
   */
  public growthModelsGrowthModelIdDownloadGet(
    requestParameters: ModellingGrowthApiGrowthModelsGrowthModelIdDownloadGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ModellingGrowthApiFp(this.configuration)
      .growthModelsGrowthModelIdDownloadGet(requestParameters.growthModelId, requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get growth model by its identifier
   * @param {ModellingGrowthApiGrowthModelsGrowthModelIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModellingGrowthApi
   */
  public growthModelsGrowthModelIdGet(
    requestParameters: ModellingGrowthApiGrowthModelsGrowthModelIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ModellingGrowthApiFp(this.configuration)
      .growthModelsGrowthModelIdGet(requestParameters.growthModelId, requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Edit a growth model
   * @param {ModellingGrowthApiGrowthModelsGrowthModelIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModellingGrowthApi
   */
  public growthModelsGrowthModelIdPut(
    requestParameters: ModellingGrowthApiGrowthModelsGrowthModelIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ModellingGrowthApiFp(this.configuration)
      .growthModelsGrowthModelIdPut(
        requestParameters.growthModelId,
        requestParameters.planId,
        requestParameters.name,
        requestParameters.isDefault,
        requestParameters.adjustmentType,
        requestParameters.adjustment,
        requestParameters.version,
        requestParameters.file,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create a new growth model
   * @param {ModellingGrowthApiGrowthModelsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModellingGrowthApi
   */
  public growthModelsPost(
    requestParameters: ModellingGrowthApiGrowthModelsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ModellingGrowthApiFp(this.configuration)
      .growthModelsPost(
        requestParameters.planId,
        requestParameters.name,
        requestParameters.isDefault,
        requestParameters.adjustmentType,
        requestParameters.adjustment,
        requestParameters.version,
        requestParameters.type,
        requestParameters.file,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModellingGrowthApi
   */
  public growthModelsTypesGet(options?: RawAxiosRequestConfig) {
    return ModellingGrowthApiFp(this.configuration)
      .growthModelsTypesGet(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const GrowthModelsGrowthModelIdPutAdjustmentTypeEnum = {
  Constant: 'constant',
  MonthsSinceRelease: 'months_since_release',
  CalendarYear: 'calendar_year',
} as const;
export type GrowthModelsGrowthModelIdPutAdjustmentTypeEnum =
  (typeof GrowthModelsGrowthModelIdPutAdjustmentTypeEnum)[keyof typeof GrowthModelsGrowthModelIdPutAdjustmentTypeEnum];
/**
 * @export
 */
export const GrowthModelsPostAdjustmentTypeEnum = {
  Constant: 'constant',
  MonthsSinceRelease: 'months_since_release',
  CalendarYear: 'calendar_year',
} as const;
export type GrowthModelsPostAdjustmentTypeEnum =
  (typeof GrowthModelsPostAdjustmentTypeEnum)[keyof typeof GrowthModelsPostAdjustmentTypeEnum];
/**
 * @export
 */
export const GrowthModelsPostTypeEnum = {
  SkrettingSalmon: 'skretting-salmon',
  EgiSalmon: 'egi-salmon',
  Sgr: 'sgr',
  Ittt: 'ittt',
  Gammon: 'gammon',
} as const;
export type GrowthModelsPostTypeEnum = (typeof GrowthModelsPostTypeEnum)[keyof typeof GrowthModelsPostTypeEnum];
